import { NAMES_ROUTES } from "@/const/routes.constants"
import { KAI_GUIDANCE_TAB_KEY } from "@/const/tab.constants"
import { Form } from "@/organisms/Form"

export const SECTION_IDS = {
  guidanceWrite: "guidance-write",
  guidanceTestImpact: "guidance-test-impact"
}

export const getHeaderItems = () => {
  const { ROOT } = NAMES_ROUTES.SETTINGS

  return [
    { link: `/${ROOT}`, tKey: "navigation.settings" },
    {
      link: `/${ROOT}/${KAI_GUIDANCE_TAB_KEY}`,
      tKey: "settings.kai-guidance.title"
    },
    {
      fieldName: "name_details",
      tKey: "settings.kai-guidance.add"
    }
  ]
}

export const getAsideItems = () => [
  {
    key: Form.Section.Details.sectionId,
    tKey: "settings.kai-guidance.form.guidanceDetails.title"
  },
  {
    key: Form.Section.Resources.sectionId,
    tKey: "settings.kai-guidance.form.scope.title"
  },
  {
    key: SECTION_IDS.guidanceWrite,
    tKey: "settings.kai-guidance.form.writeGuidance.title"
  },
  {
    key: SECTION_IDS.guidanceTestImpact,
    tKey: "settings.kai-guidance.form.testImpact.title"
  }
]
